import noReferences from './noReferences.js'

/**
 * Legacy alias over the generic `noReferences` guard.
 *
 *   condition: { collection: 'product', subCollection: 'itemLocation' }
 *
 * Prefer `noReferences` with `type: 'subCollection'` for new guards.
 */
const emptySubCollection = async (target, condition, data, getData) =>
    noReferences(target, { ...condition, type: 'subCollection' }, data, getData)

export default emptySubCollection
